
import React from "react";
import { Control } from "react-hook-form";
import { 
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage
} from "@/components/ui/form";
import { 
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useTranslation } from "react-i18next";

interface PaymentStatusFieldProps {
  control: Control<any>;
  disabled?: boolean;
}

const PaymentStatusField: React.FC<PaymentStatusFieldProps> = ({ 
  control, 
  disabled = false 
}) => {
  const { t } = useTranslation();

  return (
    <FormField
      control={control}
      name="paymentStatus"
      render={({ field }) => (
        <FormItem>
          <FormLabel className="text-sm font-medium">{t('clients.paymentStatus')}</FormLabel>
          <Select 
            onValueChange={field.onChange} 
            value={field.value}
            disabled={disabled}
          >
            <FormControl>
              <SelectTrigger className="h-11 md:h-10 text-base md:text-sm">
                <SelectValue placeholder={t('clients.selectPaymentStatus')} />
              </SelectTrigger>
            </FormControl>
            <SelectContent>
              <SelectItem value="paid">{t('clients.paid')}</SelectItem>
              <SelectItem value="partial">{t('clients.partial')}</SelectItem>
              <SelectItem value="unpaid">{t('clients.unpaid')}</SelectItem>
              <SelectItem value="pending">{t('clients.pending')}</SelectItem>
            </SelectContent>
          </Select>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

export default PaymentStatusField;
